import React, { useState } from "react";
import {
  Card,
  Table,
  Dropdown,
  Modal,
  Button,
  Form,
  Row,
  Col,
} from "react-bootstrap";
import { FaEdit, FaTrash } from "react-icons/fa";
import { CiCalendarDate } from "react-icons/ci";
import EditPlanModal from "../../modals/dashboard/packages/EditPlanModal";
import { RiDeleteBin6Line } from "react-icons/ri";
const PlansPage = ({ plans: propPlans, setPlans: setPropPlans }) => {
  // Use local state only if no props are provided
  const [localPlans, setLocalPlans] = useState([
    {
      id: 1,
      name: "Basic",
      type: "Monthly",
      subs: 56,
      price: "$50",
      date: "14 Jan 2024",
      status: "Active",
    },
    {
      id: 2,
      name: "Advanced",
      type: "Monthly",
      subs: 99,
      price: "$200",
      date: "21 Jan 2024",
      status: "Active",
    },
    {
      id: 3,
      name: "Premium",
      type: "Monthly",
      subs: 58,
      price: "$300",
      date: "10 Feb 2024",
      status: "Active",
    },
    {
      id: 4,
      name: "Enterprise",
      type: "Monthly",
      subs: 67,
      price: "$400",
      date: "18 Feb 2024",
      status: "Active",
    },
    {
      id: 5,
      name: "Basic",
      type: "Yearly",
      subs: 78,
      price: "$600",
      date: "15 Mar 2024",
      status: "Active",
    },
    {
      id: 6,
      name: "Advanced",
      type: "Yearly",
      subs: 99,
      price: "$2400",
      date: "26 Mar 2024",
      status: "Active",
    },
    {
      id: 7,
      name: "Premium",
      type: "Yearly",
      subs: 48,
      price: "$3600",
      date: "05 Apr 2024",
      status: "Active",
    },
    {
      id: 8,
      name: "Enterprise",
      type: "Yearly",
      subs: 17,
      price: "$4800",
      date: "16 Apr 2024",
      status: "Active",
    },
  ]);

  // Use provided props if available, otherwise use local state
  const plans = propPlans || localPlans;
  const setPlans = setPropPlans || setLocalPlans;

  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [editFormData, setEditFormData] = useState(null);

  /* NEW STATES */
  const [search, setSearch] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedDateRange, setSelectedDateRange] = useState("Last 7 Days");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [selectedPlanType, setSelectedPlanType] = useState("Select Plan");
  const [selectedStatus, setSelectedStatus] = useState("Select Status");
  const [sortBy, setSortBy] = useState("Last 7 Days");
  const [selectedFile, setSelectedFile] = useState(null);
  const [editPlan,setEditPlan]=useState(false)
  const [profileImage, setProfileImage] = useState(
    "/assets/img/agents/agent-01.jpg",
  );

  // Function to calculate date range
  const calculateDateRange = (rangeType) => {
    const today = new Date(2026, 3, 21); // April 21, 2026
    let startDate = new Date(today);
    let endDate = new Date(today);

    switch (rangeType) {
      case "Today":
        startDate = new Date(today);
        endDate = new Date(today);
        break;
      case "Yesterday":
        startDate = new Date(today);
        startDate.setDate(startDate.getDate() - 1);
        endDate = new Date(startDate);
        break;
      case "Last 7 Days":
        startDate = new Date(today);
        startDate.setDate(startDate.getDate() - 6);
        endDate = new Date(today);
        break;
      case "Last 30 Days":
        startDate = new Date(today);
        startDate.setDate(startDate.getDate() - 29);
        endDate = new Date(today);
        break;
      case "This Year":
        startDate = new Date(2026, 0, 1);
        endDate = new Date(today);
        break;
      case "Next Year":
        startDate = new Date(2027, 0, 1);
        endDate = new Date(2027, 11, 31);
        break;
      default:
        startDate = new Date(today);
        endDate = new Date(today);
    }

    setFromDate(startDate);
    setToDate(endDate);
  };

  // Initialize date range on mount
  React.useEffect(() => {
    calculateDateRange("Last 7 Days");
  }, []);

  // Format date as MM/DD/YYYY
  const formatDate = (date) => {
    if (!date) return "";
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  const handleEdit = (plan) => {
    setSelectedPlan(plan);
    setEditFormData({ ...plan });
    setEditPlan(true);
  };

  const handleDelete = (plan) => {
    setSelectedPlan(plan);
    setShowDelete(true);
  };

  const confirmDelete = () => {
    setPlans(plans.filter((p) => p.id !== selectedPlan.id));
    setShowDelete(false);
  };

  const handleEditFormChange = (e) => {
    const { name, value, type, checked } = e.target;
    setEditFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleEditSave = () => {
    if (editFormData) {
      const updatedPlans = plans.map((p) =>
        p.id === editFormData.id ? editFormData : p,
      );
      setPlans(updatedPlans);
      setShowEdit(false);
      setEditFormData(null);
    }
  };

  /* SEARCH FILTER WITH DROPDOWN FILTERS */

  let filteredPlans = plans.filter((plan) => {
    // Search filter
    const matchesSearch = plan.name
      .toLowerCase()
      .includes(search.toLowerCase());

    // Plan type filter
    const matchesPlanType =
      selectedPlanType === "Select Plan" || plan.type === selectedPlanType;

    // Status filter
    const matchesStatus =
      selectedStatus === "Select Status" || plan.status === selectedStatus;

    return matchesSearch && matchesPlanType && matchesStatus;
  });

  // Apply sorting
  if (sortBy === "Ascending") {
    filteredPlans = [...filteredPlans].sort((a, b) =>
      a.name.localeCompare(b.name),
    );
  } else if (sortBy === "Descending") {
    filteredPlans = [...filteredPlans].sort((a, b) =>
      b.name.localeCompare(a.name),
    );
  } else if (sortBy === "Recently Added") {
    filteredPlans = [...filteredPlans].sort((a, b) => b.id - a.id);
  }
  // Last 7 Days, Last Month, or other date-based sorting can be added with actual date logic

  /* ROW LIMIT */
  const displayedPlans = filteredPlans.slice(0, rowsPerPage);
  const [planFormData, setPlanFormData] = useState({
    name: "",
    type: "Monthly",
    position: "",
    currency: "USD",
    limitInvoices: "",
    maxCustomers: "",
    product: "",
    supplier: "",
    price: "0",
    discountType: "Fixed",
    discount: "",
    trialDays: "",
    isRecommended: false,
    accessTrial: false,
    status: "Active",
    description: "",
    modules: [], // ← Added for Plan Modules
  });
  const [addNewPlan, setAddNewPlan] = useState(false);
  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      setSelectedFile(file);
      setProfileImage(URL.createObjectURL(file));
    }
  };

  const handleCancelImage = () => {
    setProfileImage("/assets/img/agents/agent-01.jpg");
    setSelectedFile(null);
  };

  const handleFormChange = (e) => {
    const { name, value, type, checked } = e.target;
    setPlanFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  return (
    <>
      <Card
        style={{
          background: "#fff",
          // padding: "15px 20px",
        }}
        className=" shadow-sm"
      >
        {/* HEADER */}
        <Card.Header
          className="d-flex justify-content-between align-items-center flex-wrap"
          style={{ padding: "14px 18px", background: "#fff" }}
        >
          <h5 style={{ fontWeight: "600", margin: 0 }}>Plan List</h5>

          <div
            style={{
              display: "flex",
              gap: "12px",
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            {/* Date Dropdown */}
            <Dropdown>
              <Dropdown.Toggle
                style={{
                  height: "40px",
                  borderRadius: "8px",
                  border: "1px solid #e5e7eb",
                  background: "#fff",
                  color: "#111",
                  fontSize: "14px",
                  padding: "6px 14px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <CiCalendarDate style={{ fontSize: "20px" }} />{" "}
                {fromDate && toDate
                  ? `${formatDate(fromDate)} - ${formatDate(toDate)}`
                  : "Select Date"}
              </Dropdown.Toggle>

              <Dropdown.Menu
                style={{
                  borderRadius: "8px",
                  padding: "6px 0",
                  border: "1px solid #eee",
                  fontSize: "14px",
                }}
              >
                {[
                  "Today",
                  "Yesterday",
                  "Last 7 Days",
                  "Last 30 Days",
                  "This Year",
                  "Next Year",
                  "Custom Range",
                ].map((item) => (
                  <Dropdown.Item
                    key={item}
                    style={{
                      padding: "8px 16px",
                      transition: "0.2s",
                      background:
                        item === selectedDateRange ? "#f26522" : "transparent",
                      color: item === selectedDateRange ? "#fff" : "#333",
                    }}
                    onClick={() => {
                      setSelectedDateRange(item);
                      calculateDateRange(item);
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = "#f26522";
                      e.target.style.color = "#fff";
                    }}
                    onMouseLeave={(e) => {
                      if (item !== selectedDateRange) {
                        e.target.style.background = "transparent";
                        e.target.style.color = "#333";
                      }
                    }}
                  >
                    {item}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>

            {/* Select Plan */}
            <Dropdown>
              <Dropdown.Toggle
                style={{
                  height: "40px",
                  borderRadius: "8px",
                  border: "1px solid #e5e7eb",
                  background: "#fff",
                  color: "#111",
                  fontSize: "14px",
                  padding: "6px 14px",
                }}
              >
                {selectedPlanType}
              </Dropdown.Toggle>

              <Dropdown.Menu style={{ borderRadius: "8px" }}>
                <Dropdown.Item
                  style={{
                    padding: "8px 16px",
                    background:
                      selectedPlanType === "Select Plan"
                        ? "#f26522"
                        : "transparent",
                    color: selectedPlanType === "Select Plan" ? "#fff" : "#333",
                  }}
                  onClick={() => setSelectedPlanType("Select Plan")}
                  onMouseEnter={(e) => {
                    e.target.style.background = "#f26522";
                    e.target.style.color = "#fff";
                  }}
                  onMouseLeave={(e) => {
                    if (selectedPlanType !== "Select Plan") {
                      e.target.style.background = "transparent";
                      e.target.style.color = "#333";
                    }
                  }}
                >
                  Select Plan
                </Dropdown.Item>
                {["Monthly", "Yearly"].map((item) => (
                  <Dropdown.Item
                    key={item}
                    style={{
                      padding: "8px 16px",
                      background:
                        selectedPlanType === item ? "#f26522" : "transparent",
                      color: selectedPlanType === item ? "#fff" : "#333",
                    }}
                    onClick={() => setSelectedPlanType(item)}
                    onMouseEnter={(e) => {
                      e.target.style.background = "#f26522";
                      e.target.style.color = "#fff";
                    }}
                    onMouseLeave={(e) => {
                      if (selectedPlanType !== item) {
                        e.target.style.background = "transparent";
                        e.target.style.color = "#333";
                      }
                    }}
                  >
                    {item}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>

            {/* Select Status */}
            <Dropdown>
              <Dropdown.Toggle
                style={{
                  height: "40px",
                  borderRadius: "8px",
                  border: "1px solid #e5e7eb",
                  background: "#fff",
                  color: "#111",
                  fontSize: "14px",
                  padding: "6px 14px",
                }}
              >
                {selectedStatus}
              </Dropdown.Toggle>

              <Dropdown.Menu style={{ borderRadius: "8px" }}>
                <Dropdown.Item
                  style={{
                    padding: "8px 16px",
                    background:
                      selectedStatus === "Select Status"
                        ? "#f26522"
                        : "transparent",
                    color: selectedStatus === "Select Status" ? "#fff" : "#333",
                  }}
                  onClick={() => setSelectedStatus("Select Status")}
                  onMouseEnter={(e) => {
                    e.target.style.background = "#f26522";
                    e.target.style.color = "#fff";
                  }}
                  onMouseLeave={(e) => {
                    if (selectedStatus !== "Select Status") {
                      e.target.style.background = "transparent";
                      e.target.style.color = "#333";
                    }
                  }}
                >
                  Select Status
                </Dropdown.Item>
                {["Active", "Inactive"].map((item) => (
                  <Dropdown.Item
                    key={item}
                    style={{
                      padding: "8px 16px",
                      background:
                        selectedStatus === item ? "#f26522" : "transparent",
                      color: selectedStatus === item ? "#fff" : "#333",
                    }}
                    onClick={() => setSelectedStatus(item)}
                    onMouseEnter={(e) => {
                      e.target.style.background = "#f26522";
                      e.target.style.color = "#fff";
                    }}
                    onMouseLeave={(e) => {
                      if (selectedStatus !== item) {
                        e.target.style.background = "transparent";
                        e.target.style.color = "#333";
                      }
                    }}
                  >
                    {item}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>

            {/* Sort */}
            <Dropdown>
              <Dropdown.Toggle
                style={{
                  height: "40px",
                  borderRadius: "8px",
                  border: "1px solid #e5e7eb",
                  background: "#fff",
                  color: "#111",
                  fontSize: "14px",
                  padding: "6px 14px",
                }}
              >
                Sort By : {sortBy}
              </Dropdown.Toggle>

              <Dropdown.Menu style={{ borderRadius: "8px" }}>
                {[
                  "Recently Added",
                  "Ascending",
                  "Descending",
                  "Last Month",
                  "Last 7 Days",
                ].map((item) => (
                  <Dropdown.Item
                    key={item}
                    style={{
                      padding: "8px 16px",
                      background: item === sortBy ? "#f26522" : "transparent",
                      color: item === sortBy ? "#fff" : "#333",
                    }}
                    onClick={() => setSortBy(item)}
                    onMouseEnter={(e) => {
                      e.target.style.background = "#f26522";
                      e.target.style.color = "#fff";
                    }}
                    onMouseLeave={(e) => {
                      if (item !== sortBy) {
                        e.target.style.background = "transparent";
                        e.target.style.color = "#333";
                      }
                    }}
                  >
                    {item}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </Card.Header>

        {/* ROW PER PAGE + SEARCH */}

        <div className="d-flex justify-content-between align-items-center p-3 flex-wrap">
          <div className="d-flex align-items-center gap-2">
            <span>Row Per Page</span>

            <Form.Select
              style={{ width: "80px" }}
              value={rowsPerPage}
              onChange={(e) => setRowsPerPage(Number(e.target.value))}
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
            </Form.Select>

            <span>Entries</span>
          </div>

          <Form.Control
            type="text"
            placeholder="Search"
            style={{ width: "220px" }}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        {/* TABLE */}

        <Card.Body className="p-0">
          <Table responsive hover className="mb-0">
            <thead className="table-light">
              <tr>
                <th></th>
                <th>Plan Name</th>
                <th>Plan Type</th>
                <th>Total Subscribers</th>
                <th>Price</th>
                <th>Created Date</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {displayedPlans.map((plan) => (
                <tr key={plan.id}>
                  <td>
                    <Form.Check type="checkbox" />
                  </td>

                  <td className="fw-semibold">{plan.name}</td>

                  <td>{plan.type}</td>

                  <td>{plan.subs}</td>

                  <td>{plan.price}</td>

                  <td>{plan.date}</td>

                  <td>
                    <span
                      style={{ backgroundColor: "#03C95A" }}
                      className="badge "
                    >
                      ● {plan.status}
                    </span>
                  </td>

                  <td>
          <div className="d-flex gap-3">
  <FaEdit
    style={{
      cursor: "pointer",
      color: "#666d75", // light gray
      fontSize: "14px",
    }}
    onClick={() => handleEdit(plan)}
  />

  <RiDeleteBin6Line
    style={{
      cursor: "pointer",
      color: "#666d75", // even lighter gray
      fontSize: "14px",
    }}
    onClick={() => handleDelete(plan)}
  />
</div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>

      {/* EDIT MODAL */}

      <EditPlanModal
        show={editPlan}
        onHide={() => setEditPlan(false)}
        profileImage={profileImage}
        handleFileChange={handleFileChange}
        handleCancelImage={handleCancelImage}
        planFormData={planFormData}
        handleFormChange={handleFormChange}
      />
      {/* DELETE MODAL */}

      <Modal show={showDelete} onHide={() => setShowDelete(false)} centered>
        <Modal.Body className="text-center p-4">
          <div style={{ fontSize: "50px", color: "red" }}>
            <FaTrash />
          </div>

          <h4 className="mt-3">Confirm Delete</h4>

          <p>You want to delete this plan.</p>

          <div className="d-flex justify-content-center gap-3 mt-3">
            <Button variant="light" onClick={() => setShowDelete(false)}>
              Cancel
            </Button>

            <Button variant="danger" onClick={confirmDelete}>
              Yes Delete
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PlansPage;
